import { bootBlock, findBlocks } from '../../src/js/block-boot';

const initializedBlocks = new WeakMap();

function initFaq(root) {
  findBlocks(root, '.faq-block').forEach((block) => {
    if (initializedBlocks.has(block)) return;

    const tabs = block.querySelectorAll('.faq__tab');
    const panels = block.querySelectorAll('.faq__panel');

    function activateTab(index) {
      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });
      panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activateTab(index));
    });

    block.querySelectorAll('.faq__question').forEach((btn) => {
      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        const answerId = btn.getAttribute('aria-controls');
        const answer = block.ownerDocument.getElementById(answerId);

        if (!answer) return;

        btn.setAttribute('aria-expanded', String(!isOpen));
        btn.closest('.faq__item').classList.toggle('is-open', !isOpen);

        if (!isOpen) {
          answer.removeAttribute('hidden');
        } else {
          answer.setAttribute('hidden', '');
        }
      });
    });

    initializedBlocks.set(block, true);
  });
}

bootBlock('faq', initFaq);
